class AnnouncementTicker extends HTMLElement {
  connectedCallback() {
    if (this.dataset.tickerReady === 'true') return;
    this.dataset.tickerReady = 'true';
    const track = this.querySelector('.announcement-bar__ticker-track');
    const content = this.querySelector('.announcement-bar__ticker-content');
    if (!track || !content) return;

    const cleanDecorativeCopy = (node) => {
      node.setAttribute('aria-hidden', 'true');
      node.querySelectorAll('a, button, input, select, textarea').forEach((el) => {
        el.setAttribute('tabindex', '-1');
        if (el.hasAttribute('href')) el.removeAttribute('href');
      });
      node.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
    };

    const originalItems = Array.from(content.children);
    if (!originalItems.length) return;

    // Keep the ticker continuously filled, even when there is only one short announcement.
    let safety = 0;
    while (content.scrollWidth < this.clientWidth * 1.25 && safety < 20) {
      originalItems.forEach((item) => {
        const copy = item.cloneNode(true);
        cleanDecorativeCopy(copy);
        content.appendChild(copy);
      });
      safety += 1;
    }

    const clone = content.cloneNode(true);
    cleanDecorativeCopy(clone);
    track.appendChild(clone);
  }
}

if (!customElements.get('announcement-ticker')) {
  customElements.define('announcement-ticker', AnnouncementTicker);
}
